import { render, staticRenderFns } from "./Cube11.vue?vue&type=template&id=1c8b682f&"
import script from "./Cube11.vue?vue&type=script&lang=js&"
export * from "./Cube11.vue?vue&type=script&lang=js&"
import style0 from "./Cube11.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Cube11.vue"
export default component.exports